import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase yapılandırması
const firebaseConfig = {
  apiKey: "AIzaSyAFzQj2eIJ5LiMLcA-B88CkIMkK16fiSzk",
  authDomain: "app.istedad21.edu.az",
  projectId: "portalistedad",
  storageBucket: "portalistedad.firebasestorage.app",
  messagingSenderId: "659343884325",
  appId: "1:659343884325:web:6af09ab013d1e44f253fcc",
  measurementId: "G-26BG02EFCC"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// İkinci Firestore database'e bağlan (database name: imtahanyoxla)
export const db = getFirestore(app, 'imtahanyoxla');

// Firebase Auth'u başlat
export const auth = getAuth(app);

// Firebase Storage'u başlat
export const storage = getStorage(app);

export default app;
